import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { Redemption } from './redemptions.types'

const actions: ActionTree<{}, RootState> = {
  async createRedemption (_, code) {
    await this.$sohoApi.post<Redemption>(SohoModel.Redemption, { type: SohoModel.Redemption, code })
  }
}

export default actions
